import React from "react";

import { Link } from "react-router-dom";
import vc4 from './../../../images/vc4.jpg'
import vc2 from './../../../images/vc2.jpg'
import vc5 from './../../../images/vc5.jpg'
import vc6 from './../../../images/vc6.jpg'
import vc7 from './../../../images/vc7.jpg'
import vc1 from './../../../images/vc1.jpg'
import quality from './../../../images/quality.png'
import gray_dots from './../../../images/gray_dots.jpg'

import val1 from './../../../images/val1.png'

import val2  from './../../../images/val2.png'



const Fourth_Pane = () => (
    <div className=" uk-margin-large-top">
        <div className="container">
            <div className="uk-margin-large-top uk-margin-medium-bottom">
                <h1 className="uk-text-center uk-text-bold">Vally Court2 Realizations</h1>
              
            </div>
         <div class="row ">
            <div class="col-sm " >
            <div className="" 
                    style={{ backgroundImage: `url(${vc7})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    paddingBottom: '50px',
                    paddingTop: '100px',
                    height: '30vh'
                    }}
                    
            >
         
             </div>
             <div className="uk-margin-small-top" 
               
               style={{ backgroundImage: `url(${vc5})`,
               backgroundRepeat: 'no-repeat',
               backgroundSize: 'cover',
               paddingBottom: '50px',
               paddingTop: '100px',
               height: '30vh'
               }}>
             </div>


             <div className="uk-margin-small-top" 
               
               style={{ backgroundColor: '#3bcbee',
               backgroundRepeat: 'no-repeat',
               backgroundSize: 'cover',
               paddingBottom: '30px',
              
               height: '28vh'
               }}>

                   <div className="uk-padding">
                       <img src = {quality}  className="quality"/>
                       <h4 className="light">We don't compromise quality</h4>
                   </div>
             </div>




            </div>

            <div class="col-sm-6 " >
            <div className="" 
            
            style={{ backgroundImage: `url(${vc2})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            paddingBottom: '50px',
            paddingTop: '100px',
            height: '45vh'
            }}
            
            ></div>

            <div className="uk-margin-small-top" 
            
            style={{ backgroundImage: `url(${vc6})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            paddingBottom: '50px',
            paddingTop: '100px',
            height: '45vh'
            }}
            
            ></div>

            




            </div>

        <div class="col-sm" >

            <div className=""
                style={{ backgroundImage: `url(${vc4})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                paddingBottom: '50px',
                paddingTop: '100px',
                height: '60vh'
                }}
            >
               </div>

               <div className="uk-margin-small-top"
                style={{ backgroundImage: `url(${vc1})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                paddingBottom: '50px',
                paddingTop: '100px',
                height: '30vh'
                }}
            >
               </div>


        
        </div>


        
  </div>
  </div>



           <div className="uk-container">
           <div className="uk-width-1-1 uk-margin-large-top">
              <img src={val1}/>
              <img src={val2}/>
           </div>
           </div>





       {/*Next pane*/}
             <div className="uk-margin-xlarge-top">
                 <div className=""
                 style={{ backgroundImage: `url(${gray_dots})`,
                 backgroundRepeat: 'no-repeat',
                 backgroundSize: 'cover',
                 paddingBottom: '50px',
               
                 height: '70vh'
                 }}>
                <div className="uk-grid" data-uk-grid>
                     <div className="uk-width-1-2@s">
                       <div className="uk-container uk-margin-large-top ">

                           



                        



                      
                           </div>
                     </div>


                     <div className="uk-width-1-2@s">
                       <div
                         style={{ backgroundImage: `url(${vc6})`,
                         backgroundRepeat: 'no-repeat',
                         backgroundSize: 'cover',
                        
                       
                         height: '70vh'
                         }}
                       
                       >



                        </div>
                     </div>
                </div>
                </div>
             </div>












    </div>
)


export default Fourth_Pane